export enum EditPhoneSteps {
  S1PhoneForm,
  S2ConfirmPhone,
}

export enum EditPasswordSteps {
  S1Info,
  S2ConfirmPhone,
}
